var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5402 1.0391C16.6518 1.15456 16.7076 1.28733 16.7076 1.43742C16.7076 1.58752 16.6518 1.72029 16.5402 1.83575L8.73884 9.9061C8.62724 10.0216 8.49889 10.0793 8.3538 10.0793C8.20871 10.0793 8.08036 10.0216 7.96875 9.9061L0.167411 1.83575C0.0558037 1.72029 0 1.58752 0 1.43742C0 1.28733 0.0558037 1.15456 0.167411 1.0391L1.00447 0.173184C1.11607 0.0577279 1.24442 0 1.38951 0C1.5346 0 1.66295 0.0577279 1.77456 0.173184L8.3538 6.97929L14.933 0.173184C15.0446 0.0577279 15.173 0 15.3181 0C15.4632 0 15.5915 0.0577279 15.7031 0.173184L16.5402 1.0391Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.338cfa3bdff90206df7e799e1df347c7.svg";
export { ForwardRef as ReactComponent };